import { Enums } from '../common/enums'
import { DashboardComponent } from '../../helpers/dashboard-component'
import { IJsonSerializable, IOpChangeState } from '../util/interfaces'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardData } from './op-dashboard-data'
import { OpDataList } from '../util/op-data-list'
import { OpDescr } from '../core/op-descr'
import { OpFile } from '../core/op-file'

export class OpDashboard implements IOpChangeState, IJsonSerializable {

    // Properties

    public idDashboard: number
    public type: Enums.DashboardType
    public controls: OpDashboardControl[]

    public fitToScreen: boolean
    public useMargin: boolean
    public usePadding: boolean

    public padding: number[]
    public margin: number[]

    public keepAspectRatio: boolean

    public width: number;
    public maxWidth: number
    public maxHeight: number
    public backgroundColor: string
    public isTemplate: boolean
    public opState: Enums.OpChangeState

    public files: OpFile[]

    public descr: { [index: number]: OpDescr }

    public configurationSourceLevel: Enums.ReferenceType

    public configurationSourceId: number

    public name: OpDescr

    public dataList: OpDataList<OpDashboardData> = new OpDataList<OpDashboardData>()    

    public idStartupIndicator: number

    // Properties End


    // Ctor

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    // Ctor End


    // OpDashboard Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idDashboard = opObj.IdDashboard
            this.type = opObj.Type

            if (opObj.Controls) {
                this.controls = DashboardComponent.CreateDashboardControl(opObj.Controls)
            }

            this.fitToScreen = opObj.FitToScreen
            this.useMargin = opObj.UseMargin
            this.usePadding = opObj.UsePadding

            this.padding = opObj.Padding
            this.margin = opObj.Margin

            this.keepAspectRatio = opObj.KeepAspectRatio

            this.width = opObj.Width
            this.maxWidth = opObj.MaxWidth
            this.maxHeight = opObj.MaxHeight
            this.backgroundColor = opObj.BackgroundColor
            this.isTemplate = opObj.IsTemplate
            this.opState = opObj.OpState

            if (opObj.Files) {
                this.files = opObj.Files.map(file => new OpFile(file))
            }

            if (opObj.Descr) {
                this.descr = {}
                opObj.Descr.forEach((desc: { Key: string, Value: any }) => {
                    this.descr[desc.Key] = new OpDescr(desc.Value)
                })
            }

            if (opObj.DataList != null) {
                this.dataList.push(...opObj.DataList.map((data: any) => new OpDashboardData(data)))
            }

            this.configurationSourceLevel = opObj.ConfigurationSourceLevel
            this.configurationSourceId = opObj.ConfigurationSourceId

            if (opObj.Name) {
                this.name = new OpDescr(opObj.Name)
            }    
            
            if(opObj.IdStartupIndicator){
                this.idStartupIndicator = opObj.IdStartupIndicator
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            IdDashboard: this.idDashboard,
            Type: this.type,
            FitToScreen: this.fitToScreen,
            UseMargin: this.useMargin,
            UsePadding: this.usePadding,
            Padding: this.padding,
            Margin: this.margin,
            KeepAspectRatio: this.keepAspectRatio,
            Width: this.width,
            MaxWidth: this.maxWidth,
            MaxHeight: this.maxHeight,
            BackgroundColor: this.backgroundColor,
            IsTemplate: this.isTemplate,
            OpState: this.opState,
            ConfigurationSourceLevel: this.configurationSourceLevel,
            ConfigurationSourceId: this.configurationSourceId,

            DataList: this.dataList ? this.dataList.ToJSON() : null,

            IdStartupIndicator: this.idStartupIndicator,
        }
    }

    // OpDashboard Implementation End
}